import React, { useState } from 'react'
import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import ReportFooter from '../../ReportsFooter/ReportFooter'
const IncidentProcessedByWmrcTable = ({
    handleColumnSort,
    IncidentProcessedByWmrcData,
    downloadPDF,
    downloadExcel,
    DisplayDate,
    isLoading,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
}) => {
    const [currentRow, setCurrentRow] = useState(null)
    const size = useWindowSize()
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">Incidents Processed By WMRC</h1>
                <p className="fw-bold my-2">
                    Date :{' '}
                    <span className="fw-normal text-muted ">
                        {DisplayDate?.startDate} to {DisplayDate?.endDate}
                    </span>
                </p>
                <ReactExpandableTable
                    isLoading={isLoading}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    data={IncidentProcessedByWmrcData}
                    mobileColumns={mobileColumns}
                    handleColumnSort={handleColumnSort}

                />
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">Unreviewed Incidents Processed By WMRC Report</h1>
            <p className="fw-bold my-2">
                Date :{' '}
                <span className="fw-normal text-muted ">
                    {DisplayDate?.startDate} to {DisplayDate?.endDate}
                </span>
            </p>

            <ReactDataTable
                isLoading={isLoading}
                data={IncidentProcessedByWmrcData}
                columns={columns}
                removePagination={true}
                handleColumnSort={handleColumnSort}
            />


            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
            />
        </>
    );

}

export default IncidentProcessedByWmrcTable
